/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addresshiddenhint2Inputs */

const en_addresshiddenhint2 = /** @type {(inputs: Addresshiddenhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone sees the city. Guests with a ticket, a sign-up or an accepted request see the exact address.`)
};

const de_addresshiddenhint2 = /** @type {(inputs: Addresshiddenhint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle sehen die Stadt. Die genaue Adresse sehen Gäste mit Ticket, Anmeldung oder angenommener Anfrage.`)
};

/**
* | output |
* | --- |
* | "Everyone sees the city. Guests with a ticket, a sign-up or an accepted request see the exact address." |
*
* @param {Addresshiddenhint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addresshiddenhint2 = /** @type {((inputs?: Addresshiddenhint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addresshiddenhint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addresshiddenhint2(inputs)
	return de_addresshiddenhint2(inputs)
});
export { addresshiddenhint2 as "addressHiddenHint" }